import ModelArticle from './ModelArticle';
import { keywordSets } from '../PageSeo';
import { ATTO2_VIDEO } from '../atto2Video';
import banner from '../images/atto2/1stBanner.jpg';
import realFront from '../images/atto2/real-front.jpg';
import realRear from '../images/atto2/real-rear.jpg';
import realCockpit from '../images/atto2/real-cockpit.jpg';
import interior01 from '../images/atto2/interior-01.jpg';
import charging01 from '../images/atto2/charging-01.jpg';
import v2l01 from '../images/atto2/v2l-01.jpg';

export const atto2ArticleMeta = {
  slug: 'byd-atto-2-indonesia-pre-book',
  title: 'BYD Atto 2 Indonesia: SUV Kompak Listrik Blade Battery 2.0, Open Pre-Book',
  description:
    'Panduan BYD Atto 2 untuk Indonesia: posisi di antara Atto 1 dan Atto 3, Blade Battery 2.0 dengan Flash Charging 9 menit, desain Dragon Face, kabin lega, status pre-book, dan perkiraan harga dari data NJKB.',
  image: realFront,
  contentLength: '950 kata',
};

const article = {
  slug: atto2ArticleMeta.slug,
  metaTitle: atto2ArticleMeta.title,
  metaDescription: atto2ArticleMeta.description,
  keywords: [
    ...keywordSets.atto2,
    ...keywordSets.localDealer,
    'BYD Atto 2 review',
    'BYD Atto 2 NJKB',
    'BYD Atto 2 vs Jaecoo J5 EV',
    'SUV listrik 300 jutaan',
  ],
  datePublished: '2026-11-01',
  heroImage: banner,
  heroAlt: 'BYD Atto 2 Hiking Green tampak depan di tepi laut',
  eyebrow: 'BYD Atto 2 · Open Pre-Book',
  heroTitle: 'BYD Atto 2: SUV kompak listrik dengan Blade Battery 2.0, sudah bisa di-pre-book',
  heroText:
    'Atto 2 mengisi celah antara Atto 1 dan Atto 3: SUV listrik sepanjang 4,31 meter dengan kabin lega, desain Dragon Face, dan Blade Battery 2.0 yang bisa diisi 10-97 persen dalam sekitar 9 menit. Pre-book sudah dibuka di BYD Arista BSD City, harga resmi Indonesia menyusul.',
  modelPath: '/jelajahi-atto2',
  modelLabel: 'Lihat halaman BYD Atto 2',
  waMessage:
    'Halo Junius, saya baca artikel BYD Atto 2 dan ingin pre-book. Mohon info ketentuan tanda jadi, pilihan tipe dan warna, serta estimasi pengiriman.',
  quickSpecs: [
    { label: 'Panjang bodi', value: '4,31 m' },
    { label: 'Flash Charging', value: '10-97% 9 menit' },
    { label: 'Jarak tempuh', value: '312 km WLTP' },
    { label: '0-100 km/jam', value: '7,9 detik' },
    { label: 'Bagasi', value: '400-1.340 L' },
  ],
  video: {
    ...ATTO2_VIDEO,
    eyebrow: 'Video unit asli',
    title: 'Tonton walkaround BYD Atto 2',
    note: 'Video 1 menit 12 detik, diputar saat Anda menekan play supaya hemat kuota. Ketuk momen untuk melompat.',
  },
  sections: [
    {
      title: 'Posisi BYD Atto 2 di jajaran BYD Indonesia',
      paragraphs: [
        'BYD Atto 1 adalah city car listrik mulai Rp199 juta, BYD Atto 3 adalah SUV listrik keluarga seharga Rp415 juta. Di antara keduanya ada ruang untuk SUV kompak yang cukup lega untuk keluarga kecil tetapi tetap lincah di jalan kota, dan di situlah Atto 2 masuk. Panjangnya 4.310 mm, lebar 1.830 mm, tinggi 1.675 mm, dengan wheelbase 2.620 mm dan ground clearance 165 mm yang aman untuk polisi tidur dan jalan berlubang.',
        'BYD Indonesia memamerkan Atto 2 pada 13 Oktober 2026 di Jakarta Selatan, berbarengan dengan peluncuran Danza Z9 GT dan New D9. Sehari kemudian Presiden Direktur PT BYD Motor Indonesia memastikan Atto 2 versi Indonesia memakai Blade Battery 2.0 dengan Flash Charging, menunggu kesiapan pabrik.',
      ],
    },
    {
      title: 'Blade Battery 2.0 dan Flash Charging: 9 menit untuk 97 persen',
      paragraphs: [
        'Pembeda terbesar Atto 2 versi Indonesia dari versi yang lebih dulu dijual di Eropa adalah baterainya. Blade Battery 2.0 mendukung BYD Flash Charging dengan klaim 10 ke 70 persen sekitar 5 menit dan 10 ke 97 persen sekitar 9 menit di BYD Flash Charger. Untuk pemakaian harian, artinya mampir sebentar saat ngopi sudah cukup untuk mengisi hampir penuh.',
        'Sebagai referensi, Atto 2 di Eropa menempuh hingga 312 km WLTP dengan akselerasi 0-100 km/jam 7,9 detik dan kecepatan maksimum 160 km/jam. Kapasitas baterai, tenaga motor, dan jarak tempuh versi Indonesia dikonfirmasi BYD Motor Indonesia saat peluncuran.',
      ],
    },
    {
      title: 'Desain Dragon Face dan kabin yang terasa lebih besar dari ukurannya',
      paragraphs: [
        'Wajahnya memakai bahasa desain Dragon Face karya Wolfgang Egger dengan lampu LED tajam yang menyatu ke garis grille, overhang pendek, dan lekukan bodi bertenaga. Lampu belakangnya menerus selebar bodi dengan motif cincin Möbius. Di Eropa tersedia empat warna: Hiking Green, Climbing Grey, Skiing White, dan Cosmos Black.',
        'Di dalam, e-Platform 3.0 dengan baterai ringkas membebaskan ruang kepala dan kaki untuk penumpang depan maupun belakang. Head unit 12,8 inci bisa diputar, panel instrumen digital 8,8 inci, jok vegan leather berlubang dengan jahitan kontras, kursi elektrik berpenghangat, sunroof panoramik, ambient light, dan wireless charging. Bagasi 400 liter bisa diperluas menjadi 1.340 liter dengan melipat kursi belakang, ditambah penyimpanan pintar di kabin.',
      ],
    },
    {
      title: 'Teknologi di baliknya',
      paragraphs: [
        'Struktur Cell-to-Body menyatukan baterai dengan bodi sehingga kekakuan torsional naik 32 persen. Powertrain 8-in-1 menggabungkan VCU, BMS, MCU, PDU, DC-DC, onboard charger, motor, dan transmisi dalam satu modul yang hemat ruang dan energi. Heat pump menjadi standar, sistem ADAS tersedia di semua tipe, dan BYD Intelligent Cockpit menghadirkan 4G, navigasi, Android Auto, Apple CarPlay, kontrol suara, serta pembaruan OTA. Kunci NFC lewat kartu atau ponsel dan AC yang bisa dinyalakan dari jauh melengkapi paketnya, ditambah V2L untuk menyalakan perangkat di luar mobil.',
      ],
    },
    {
      title: 'Harga dan cara pre-book BYD Atto 2',
      paragraphs: [
        'Harga OTR resmi belum diumumkan. Dua kode tipe Atto 2 sudah terdaftar di data NJKB Samsat DKI Jakarta dengan nilai Rp245 juta sampai Rp281 juta, indikasi dua varian Standard dan Extended Range. Perlu diingat NJKB bukan harga jual karena belum termasuk pajak, BBN, dan komponen lain, sehingga perkiraan media di kisaran Rp300 jutaan masih harus menunggu pengumuman BYD.',
        'Pre-book resmi dibuka 30 Oktober 2026 di BYD Arista BSD City bersama BYD Ti7. Pemesan awal mendapat prioritas unit dan penawaran eksklusif, lalu dikabari lebih dulu saat harga resmi keluar. Hubungi Junius untuk ketentuan tanda jadi, pilihan tipe dan warna, serta estimasi pengiriman.',
      ],
    },
  ],
  specTitle: 'Referensi spesifikasi BYD Atto 2',
  specRows: [
    ['Segmen', 'Compact SUV listrik, 5 penumpang'],
    ['Dimensi (P x L x T)', '4.310 x 1.830 x 1.675 mm'],
    ['Wheelbase', '2.620 mm'],
    ['Ground clearance', '165 mm'],
    ['Platform', 'e-Platform 3.0, penggerak roda depan, CTB'],
    ['Baterai (Indonesia)', 'Blade Battery 2.0 dengan Flash Charging, 10-97% sekitar 9 menit'],
    ['Jarak tempuh', 'Hingga 312 km WLTP kombinasi'],
    ['Akselerasi 0-100 km/jam', '7,9 detik, kecepatan maksimum 160 km/jam'],
    ['Layar', 'Head unit putar 12,8 inci, instrumen digital 8,8 inci'],
    ['Kenyamanan', 'Sunroof panoramik, wireless charging, ambient light, kursi elektrik berpenghangat, heat pump'],
    ['Bagasi', '400 L, hingga 1.340 L kursi belakang dilipat'],
    ['Konektivitas', '4G, Android Auto, Apple CarPlay, kontrol suara, OTA, kunci NFC'],
    ['Status Indonesia', 'Open pre-book sejak 30 Oktober 2026, harga resmi menyusul'],
  ],
  specNote: 'Tenaga motor, kapasitas baterai, dan kelengkapan per varian untuk Indonesia dikonfirmasi BYD Motor Indonesia saat peluncuran.',
  galleryTitle: 'BYD Atto 2 dari dekat',
  gallery: [
    { src: realFront, ratio: 125, alt: 'BYD Atto 2 Hiking Green di jalan', title: 'Unit produksi', text: 'Foto asli, bukan render.' },
    { src: realRear, ratio: 125, alt: 'Lampu belakang Möbius BYD Atto 2', title: 'Lampu belakang Möbius', text: 'Lampu menerus selebar bodi.' },
    { src: realCockpit, ratio: 125, alt: 'Kokpit BYD Atto 2 dengan layar putar', title: 'Kokpit', text: 'Head unit putar 12,8 inci dan instrumen digital.' },
    { src: interior01, ratio: 50, alt: 'Dashboard BYD Atto 2', title: 'Material berkualitas', text: 'Vegan leather dan panel pintu premium.' },
    { src: charging01, ratio: 50, alt: 'BYD Atto 2 sedang diisi daya', title: 'Pengisian cepat', text: 'Versi Indonesia memakai Flash Charging.' },
    { src: v2l01, ratio: 50, alt: 'BYD Atto 2 menyalakan perangkat lewat V2L', title: 'V2L', text: 'Menyalakan perangkat luar langsung dari baterai mobil.' },
  ],
  faqs: [
    {
      q: 'Kapan BYD Atto 2 meluncur di Indonesia?',
      a: 'Atto 2 sudah diperkenalkan 13 Oktober 2026 dan pre-book dibuka 30 Oktober 2026 di BYD Arista BSD City. Tanggal peluncuran resmi dan pengiriman menunggu pengumuman BYD Motor Indonesia.',
    },
    {
      q: 'Berapa harga BYD Atto 2?',
      a: 'Harga OTR resmi belum dirilis. Nilai NJKB Rp245-281 juta bukan harga jual. Pemesan pre-book dikabari lebih dulu begitu harga resmi keluar.',
    },
    {
      q: 'Apa kelebihan Atto 2 dibanding Atto 1 dan Atto 3?',
      a: 'Atto 2 lebih lega dari Atto 1 dengan bodi SUV 4,31 meter dan ground clearance 165 mm, tetapi lebih ringkas dan lincah dari Atto 3. Versi Indonesia memakai Blade Battery 2.0 dengan Flash Charging.',
    },
    {
      q: 'Bagaimana cara pre-book BYD Atto 2 di BSD Serpong?',
      a: 'Hubungi Junius lewat WhatsApp untuk ketentuan tanda jadi, pilihan tipe dan warna, estimasi pengiriman, dan penawaran eksklusif pemesan awal.',
    },
  ],
  related: [
    { label: 'Halaman model BYD Atto 2: foto, warna, dan interior', to: '/jelajahi-atto2' },
    { label: 'BYD Ti7 Indonesia: SUV 7-seater DM-p hybrid, open pre-book', to: '/blog/byd-ti7-indonesia-suv-7-seater-hybrid' },
    { label: 'Harga BYD Atto 1 NIK 2026 di BSD Serpong', to: '/blog/harga-byd-atto-1-bsd-serpong-junius' },
    { label: 'BYD Atto 3: SUV listrik stylish', to: '/blog/atto-3-suv-listrik-stylish' },
  ],
  ctaTitle: 'Pre-book BYD Atto 2 sekarang',
  ctaText:
    'Pre-book BYD Atto 2 sudah dibuka di BYD Arista BSD City. Hubungi Junius untuk ketentuan tanda jadi, pilihan warna, dan penawaran eksklusif pemesan pertama.',
};

function Atto2Article() {
  return <ModelArticle article={article} />;
}

export default Atto2Article;
